import { render, staticRenderFns } from "./BNumber.vue?vue&type=template&id=09940294&scoped=true&"
import script from "./BNumber.vue?vue&type=script&lang=js&"
export * from "./BNumber.vue?vue&type=script&lang=js&"
import style0 from "./BNumber.vue?vue&type=style&index=0&id=09940294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09940294",
  null
  
)

export default component.exports